/* eslint-disable */

window.preloadNextVideo = function () {
  const number = window.headerVideoPlaying + 1;
  const video = document.querySelectorAll('.teaser__video')[number];
  if (video) {
    let currentSrc = video.currentSrc;
    if (!window.videosLoaded.includes(currentSrc)) {
      window.videosLoaded.push(currentSrc);
      video.removeAttribute('poster');
      video.load();
      video.removeEventListener('ended', playNextVideo, false);
      video.addEventListener('ended', playNextVideo, false);
      console.log("Preload: " + currentSrc);
    }
  }
}

window.playNextVideo = function () {
  console.log('Video ' + window.headerVideoPlaying + ' ended');
  let nowPlaying = document.querySelectorAll('.teaser__video')[window.headerVideoPlaying];
  if (nowPlaying) {
    nowPlaying.pause();
    nowPlaying.style.display = 'none';
    nowPlaying.currentTime = 0;
  }
  window.headerVideoPlaying++;
  let video = document.querySelectorAll('.teaser__video')[window.headerVideoPlaying];
  if (!video) {
    console.log('last video. Start first');
    window.headerVideoPlaying = 0;
    // alle anderen einmal ausblenden
    //document.querySelectorAll('.teaser__video')
  }
  console.log('video: ' + window.headerVideoPlaying);
  video = document.querySelectorAll('.teaser__video')[window.headerVideoPlaying];
  if (video) {
    video.currentTime = 0;
    video.style.display = 'block';
    video.play();
    console.log('Current Playing: ' + video.currentSrc);
    preloadNextVideo();
  } else {
    console.log('no video');
  }
}

window.headerVideoPlaying = 0;
window.videosLoaded = [];

if (window.shuffledVideos && window.shuffledVideos === 1) {
  // Alle Videos in eine Array-Referenz umwandeln
  const videoContainer = document.querySelector('.teaser__videos__wrapper'); // Eltern-Element
  const videos = Array.from(document.querySelectorAll('.teaser__video'));

  for (let i = videos.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [videos[i], videos[j]] = [videos[j], videos[i]];
  }

  // Neu angeordnete Videos in den Container setzen
  videos.forEach(video => videoContainer.appendChild(video));
}

const videos = document.querySelectorAll('.teaser__video');
const teaser__mobile__image = document.querySelector('.teaser__mobile__image');

if (videos.length > 1) {
  // wir muessen die Videos nacheinander abspielen
  if (!teaser__mobile__image || (teaser__mobile__image && window.innerWidth >= 568)) {
    // wenn wir kein mobiles bild haben oder wir ein bild haben und groesser als 568px sind, dann wollen wir das video anzeigen
      const video = videos[0];
      video.currentTime = 0;
      const currentSrc = video.currentSrc;
      window.videosLoaded.push(currentSrc);
      video.setAttribute('preload', 'auto');
      video.style.display = 'block';
      video.load();
      video.play();
      console.log('Current Playing: ' + video.currentSrc);
      video.addEventListener('ended', playNextVideo, false);
      preloadNextVideo();
  } else {
    teaser__mobile__image.classList.remove('d-sm-none')
  }
}

window.pauseVideo = function() {
  let nowPlaying = document.querySelectorAll('.teaser__video')[window.headerVideoPlaying];
  if (nowPlaying) {
    nowPlaying.pause();
  }
}

window.playVideo = function() {
  let nowPlaying = document.querySelectorAll('.teaser__video')[window.headerVideoPlaying];
  if (nowPlaying) {
    nowPlaying.play();
  }
}
